/** App-wide constants. Keep magic strings out of components. */

export const APP_NAME    = 'Lincoln School';
export const APP_TAGLINE = "A school you can talk to.";
export const SUPPORT_EMAIL = 'hello@lincoln.school';
export const SUPPORT_PHONE = '+358 41 575 1803';

export const STORAGE_KEYS = {
  TOKEN: 'lc.token',
  LANG:  'lc.lang',
  THEME: 'lc.theme',
};

// `country` is the ISO 3166-1 alpha-2 code used by the flag-icons CSS
// library (.fi.fi-us etc). It differs from the language code in a few
// places: en → us, sv → se (Sweden), ur → pk (Pakistan), ar → sa, zh → cn.
export const LANGUAGES = [
  { code: 'en', label: 'English',  country: 'us', flag: '🇺🇸' },
  { code: 'fi', label: 'Suomi',    country: 'fi', flag: '🇫🇮' },
  { code: 'sv', label: 'Svenska',  country: 'se', flag: '🇸🇪' },
  { code: 'mt', label: 'Malti',    country: 'mt', flag: '🇲🇹' },
  { code: 'es', label: 'Español',  country: 'es', flag: '🇪🇸' },
  { code: 'fr', label: 'Français', country: 'fr', flag: '🇫🇷' },
  { code: 'ur', label: 'اردو',     country: 'pk', flag: '🇵🇰' },
  { code: 'ar', label: 'العربية',  country: 'sa', flag: '🇸🇦' },
  { code: 'zh', label: '中文',      country: 'cn', flag: '🇨🇳' },
];

export const ROLES = {
  LEARNER:  'learner',
  PROVIDER: 'provider',
  TUTOR:    'tutor',
  ADMIN:    'admin',
};
